module.exports = __webpack_public_path__ + "img/program.f58052ac.jpeg";